module.exports = fn => x => !fn(x)
